import styled, { DefaultTheme } from 'styled-components';

import { dsRadius } from '@/config/colors';
import type { PaymentTone } from '@/utils/paymentLabels';

/* `ds` nie ma kolorów stanów, więc bierzemy skale z motywu (te same, co reszta plakietek).
   W trybie ciemnym odwracamy skalę zamiast dokładać półprzezroczyste tła. */
const scaleOf = (theme: DefaultTheme, tone: PaymentTone) => {
  if (tone === 'ok') return theme.colors.success;
  if (tone === 'warn') return theme.colors.warning;
  return theme.colors.danger;
};

/** Pigułka spóźnionej wpłaty. Zawija się na wąskim ekranie zamiast rozpychać wiersz. */
export const Pill = styled.span<{ $tone: PaymentTone }>`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  max-width: 100%;
  padding: 3px 9px;
  /* Nie 999px: na telefonie tekst łamie się na dwie linie i pełna pigułka robi się owalem. */
  border-radius: ${dsRadius['8']};
  font-size: 11px;
  font-weight: 600;
  line-height: 1.35;
  cursor: help;
  color: ${({ $tone, theme }) => scaleOf(theme, $tone)[theme.mode === 'dark' ? 200 : 700]};
  background: ${({ $tone, theme }) => scaleOf(theme, $tone)[theme.mode === 'dark' ? 900 : 100]};

  svg { width: 12px; height: 12px; flex-shrink: 0; }
`;

export const HintTrigger = styled.span`
  display: inline-flex;
  max-width: 100%;
  cursor: help;
`;

export const HintContent = styled.div`
  max-width: 280px;
  padding: 6px 4px;
  font-size: 12px;
  line-height: 1.45;
`;

export const CalloutWrap = styled.div<{ $margin: string }>`
  margin: ${({ $margin }) => $margin};
`;

export const BadgeLine = styled.div`
  display: flex;
  margin-top: 4px;
`;
